import { Grid, Button } from '@mui/material';
import * as Yup from 'yup';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { FormInput } from '../../components/hook-form/form-input.component';
import { Note } from '../../models/note';
import { useSaveData } from '../../hooks/useSaveData';
import { noteApiKeyStore } from '../../api/note-api-key-store';
import { LoadingIndicator } from '../../components/loading-indicator.component';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface NoteRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  unitID?: number;
  noteTempEntityID?: number;
}

interface NoteCreateFromProps {
  noteRequestArgs?: NoteRequestArgs;
  note?: Note;
  onSaveComplete: (data: Note) => void;
  onClosed: () => void;
}

const noteValidationSchema = Yup.object().shape({
  note: Yup.string().required('Note is required'),
});

export const SaveNoteFrom = ({ note, noteRequestArgs, onSaveComplete, onClosed }: NoteCreateFromProps) => {
  const { isLoading, mutateAsync } = useSaveData<Note>(
    note ? noteApiKeyStore.updateNote() : noteApiKeyStore.createNote()
  );
  const form = useReactHookForm({ defaultValues: note, yupSchema: noteValidationSchema });

  const handleSubmit = async (note: any) => {
    const data = await mutateAsync({ data: { ...note, ...noteRequestArgs } });
    onSaveComplete(data.data);
    form.reset({ note: '', noteSection: '' });
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <ReactHookForm formName="SEVE_FORM" onSubmit={handleSubmit} formContextProps={form}>
      <Grid container spacing={2}>
        <Grid item lg={10} sm={10} xl={10} xs={10}>
          <LoadingIndicator isLoading={isLoading} />
          <div className="mb-1" style={{ marginBottom: '8px' }}>
            <FormInput name="note" label="Note" multiline={true} size={3.5} autoFocus />
          </div>
        </Grid>
        <Grid item lg={2} sm={2} xl={2} xs={2}>
          <Button type="button" variant="contained" fullWidth onClick={() => form.handleSubmit(handleSubmit)()}
            disabled={isReadOnlyPermission}>
            Save
          </Button>
          <Button style={{ marginTop: 10 }} type="button" variant="outlined" fullWidth onClick={onClosed}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </ReactHookForm>
  );
};
